import { render, staticRenderFns } from "./ModalConfigDeposit.vue?vue&type=template&id=db34e32a&scoped=true"
import script from "./ModalConfigDeposit.vue?vue&type=script&lang=js"
export * from "./ModalConfigDeposit.vue?vue&type=script&lang=js"
import style0 from "./ModalConfigDeposit.vue?vue&type=style&index=0&id=db34e32a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db34e32a",
  null
  
)

export default component.exports